import { HttpParams } from '@angular/common/http';

export function buildHttpParams(params: Record<string, any>, excludeFields: string[] = []): HttpParams {
  return Object.entries(params)
    .filter(([key, _]) => !excludeFields.includes(key))
    .filter(([_, value]) => isValidValue(value))
    .reduce((httpParams, [key, value]) => {
      if (Array.isArray(value)) {
        return value.reduce((acc, item) => acc.append(key, item), httpParams);
      }
      return httpParams.append(key, String(value));
    }, new HttpParams());
}

export function buildFormData(params: Record<string, any>): FormData {
  return Object.entries(params)
    .filter(([_, value]) => isValidValue(value))
    .reduce((formData, [key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(item => formData.append(key, item));
      } else {
        formData.append(key, value);
      }
      return formData;
    }, new FormData());
}

function isValidValue(value: any): boolean {
  return value !== undefined && value !== null && value !== '' && (!Array.isArray(value) || value.length > 0);
}
